import { render, staticRenderFns } from "./assessmentRules.vue?vue&type=template&id=24a28ff3&scoped=true&"
import script from "./assessmentRules.vue?vue&type=script&lang=js&"
export * from "./assessmentRules.vue?vue&type=script&lang=js&"
import style0 from "./assessmentRules.vue?vue&type=style&index=0&id=24a28ff3&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a28ff3",
  null
  
)

export default component.exports